import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import theme from './NoPermissionsPlaceholder.scss';

export const NoPermissionsPlaceholder = () => (
  <div className={ theme.root }>
    <FormattedHTMLMessage
      id="NoPermissions.Label"
      defaultMessage="** Sorry, you have no permissions. <br/> Please contact your system administrator"
    />
  </div>
);
